import CityPage from '../../components/CityPage';

const cityData = {
    name: "Touques",
    slug: "touques",
    postalCode: "14800",
    intro: "Vous avez besoin d'un débarras à Touques ? CC Débarras 14 intervient rapidement sur toute la commune pour vider vos maisons, appartements, caves ou greniers. Que ce soit dans le cadre d'une succession, d'une vente immobilière ou d'un départ en maison de retraite, nous prenons en charge l'intégralité du débarras avec soin et discrétion. Débarras gratuit sous conditions, devis sans engagement.",
    nearby: ["Deauville", "Trouville-sur-Mer", "Tourgéville", "Saint-Arnoult", "Bénerville-sur-Mer"],
};

const Touques = () => <CityPage city={cityData} />;

export default Touques;
